import { render, staticRenderFns } from "./DispenserList.vue?vue&type=template&id=48948840"
import script from "./DispenserList.vue?vue&type=script&lang=js"
export * from "./DispenserList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports